import React from "react";
import deposit from "../../assets/deposit.svg";
import withdraw from "../../assets/withdraw.svg";
import swap from "../../assets/swapppp.svg";
import chart from "../../assets/Chart.svg";
import N from "../../assets/N.svg";
import taskImg from "../../assets/task.svg";
import tasksObject from "../../data/uncompletedTasks";
import del from "../../assets/delete.svg";
import { useNavigate } from "react-router";

function DashHome() {
  const navigate = useNavigate();
  return (
    <div className="px-[22px] bg-[#FCFCF6] h-full md:pt-[43px] pb-[50px] md:w-[70vw] w-[100vw] ">
      <div className="md:flex gap-[112px]">
        <div className="">
          <div
            className="w-full md:w-[419px] h-auto rounded-[4px] bg-[#FBC108] mb-[16px] mx-auto p-[16px] shadow-dash "
            style={{
              backgroundImage: N,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right",
            }}
          >
            <h1 className="text-2xl font-black mb-12 text-white">
              Check out our cool products
            </h1>

            <button
              className="bg-[#FFFFFF]/80 w-[104px] h-[32px] text-xs flex items-center justify-center rounded-[4px] hover:bg-opacity-90  "
              onClick={() => {
                navigate("/ecom");
              }}
            >
              Shop Now
            </button>
          </div>
          <div className="w-full md:w-[419px]  h-auto rounded-[4px] bg-[#5D5B5B] mb-[33px] mx-auto  p-[16px] shadow-dash">
            <select
              name="tokens"
              id=""
              className="w-[51px] h-[30px] text-sm rounded-sm mb-[16px]"
            >
              <option value="tyrion">TYR</option>
              <option value="bitcoin">BTC</option>
              <option value="ethereum">ETH</option>
            </select>
            <p className="text-white font-bold text-2xl mb-[16px]">
              25,000 <span className="text-sm">TYR</span>
            </p>
            <div className="flex items-center gap-[16px] justify-between">
              <button className="bg-[#FFFFFF]/80 w-[104px] h-[32px] text-xs flex items-center justify-center rounded-[4px] hover:bg-opacity-90  ">
                <div className="text-sm flex items-center gap-2">
                  <img src={swap} alt="" />
                  <p>Swap</p>
                </div>
              </button>
              <button className="bg-[#FFFFFF]/80 w-[104px] h-[32px] text-xs flex items-center justify-center rounded-[4px] hover:bg-opacity-90  ">
                <div className="text-sm flex items-center gap-2">
                  <img src={deposit} alt="" />
                  <p>Deposit</p>
                </div>
              </button>
              <button className="bg-[#FFFFFF]/80 w-[104px] h-[32px] text-xs flex items-center justify-center rounded-[4px] hover:bg-opacity-90  ">
                <div className="text-sm flex items-center gap-2">
                  <img src={withdraw} alt="" />
                  <p>Withdraw</p>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div>
          <h6 className="text-sm md:text-2xl md:mb-[50px] mb-[25px] ">
            Conversion of Naira to Tyrion
          </h6>
          <form action="" className="mb-[21px] md:mb-[50px] ">
            <div className="flex flex-col gap-[10px]">
              <label htmlFor="">Amount</label>
              <input
                type="number"
                className="w-full text-sm h-[39px] pl-[18px] "
                placeholder="Enter amount in ( ₦ )"
              />
            </div>
          </form>
          <h6 className="text-sm mb-[17px]">Equivalent tyrion amount</h6>
          <div className="w-full h-[2px] bg-[#fcb108]"></div>
          <div className="flex justify-end">
            <div className="border-2 border-[#000000]/21 md:w-auto md:p-[20px]  w-[126px] h-[39px] font-bold text-sm md:text-2xl flex items-center justify-center mt-[16px]">
              = 28,400 tokens
            </div>
          </div>
        </div>
      </div>
      <div className="mt-[55px]">
        <h6 className="">Trading Chart</h6>
        <img src={chart} alt="" className="w-full mt-[19px]" />
      </div>
      <div className="mt-[40px] ">
        <h6>Uncompleted tasks</h6>
        <div className="mt-[15px] flex flex-col gap-4 ">
          {tasksObject.map((task) => {
            return (
              <div className="w-full h-auto md:h-[60px] bg-[#ffffff] rounded-[8px] shadow-two flex items-center py-[10px] px-[30px] ">
                <img src={taskImg} alt="" className="md:mr-[40px] mr-[20px]" />
                <div className="flex flex-col text-[#3f3f3f]/70 mr-auto ">
                  <p className="text-[10px] md:text-base">{task.description}</p>
                  <p className="text-[8px] md:text-sm">{task.day}</p>
                </div>
                <img src={del} alt="" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default DashHome;
